import { Button, Tag } from 'antd';
import { useNavigate } from 'react-router-dom';
import { getAccountRecommendedAction, getAccountReadinessDisplay } from '../utils/accountReadiness';

const AccountReadinessStatus = ({
  account,
  showAction = true,
  showHint = true,
  showMessage = true,
  actionStyle = {},
}) => {
  const navigate = useNavigate();
  const display = getAccountReadinessDisplay(account);
  const action = getAccountRecommendedAction(account);

  return (
    <div>
      <Tag color={display.statusColor} style={{ marginBottom: 4 }}>
        {display.statusText}
      </Tag>
      {showMessage ? (
        <div style={{ color: '#666', fontSize: 12, lineHeight: 1.5 }}>
          {display.message}
        </div>
      ) : null}
      {showHint && display.hintText ? (
        <div style={{ color: '#999', fontSize: 12, lineHeight: 1.5, marginTop: 4 }}>
          {display.hintText}
        </div>
      ) : null}
      {showAction && action ? (
        <Button
          type="link"
          size="small"
          style={{ padding: 0, marginTop: 4, ...actionStyle }}
          onClick={() => navigate(action.path)}
        >
          {action.label}
        </Button>
      ) : null}
    </div>
  );
};

export default AccountReadinessStatus;
